import React from "react";
import { Container, Row, Col, Button } from "react-bootstrap";
import "./Intro.css";
import selfesteem from "../../../img/test-images/intro-images/selfesteem-intro.svg";
import clock from "../../../img/test-images/clock.svg";

function Intro() {
  return (
    <div className="intro-div">
      <Container className="intro-container">
        <Row>
          <Col md={6}>
            <img src={selfesteem} alt="self-esteem" />
          </Col>
          <Col md={6}>
            <p>
              Self-esteem is a person's overall sense of self-worth or personal
              value. It usually involves a variety of beliefs about yourself,
              such as the appraisal of your own appearance, beliefs, emotions,
              and behaviors. Put in simple terms, self-esteem is how much do you
              appreciate, like and be kind to yourself. Self-esteem plays a
              significant role in your motivation and success throughout your
              life. Knowing your self-esteem is a way to know yourself, and your
              motives and choices better.
            </p>
            <p>
              To have a better understanding of your self-esteem, click the
              button below to proceed to the quiz.
            </p>
            <div className="test-time">
              <img src={clock} alt="time" />2 - 3 minutes
            </div>
            <Button
              variant="secondary"
              size="lg"
              href="/selfevaluation/self-esteem/quiz"
            >
              Proceed
            </Button>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Intro;
